// extracted by mini-css-extract-plugin
module.exports = {"button":"AddContactButton_button__3xl9A","icon":"AddContactButton_icon__q85nz"};